/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://2z7awiifhc.execute-api.eu-central-1.amazonaws.com/prodnorway",
            "region": "eu-central-1"
        },
        {
            "name": "CommonQueries",
            "endpoint": "https://dal8jxxfe8.execute-api.eu-central-1.amazonaws.com/prodnorway",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ulvc6vaumbfutmv66zaypqtijm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-d3rt7apchjhwnle4dk3rc3sody",
    "aws_cognito_identity_pool_id": "eu-central-1:4071b631-2029-48a8-9b3b-5cd4b45404a6",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_LLDdYtIRM",
    "aws_user_pools_web_client_id": "qjo3nt4tq69u4ii1pdr497vj8",
    "oauth": {
        "domain": "content-prodnorway.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "openid",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://content-no.bauermediaoutdoor.com/",
        "redirectSignOut": "https://content-no.bauermediaoutdoor.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 14,
        "passwordPolicyCharacters": [
            "REQUIRES_UPPERCASE",
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "materialportal-assets143357-prodnorway",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
